import { render, staticRenderFns } from "./TransportadoraTpCalcImportarForm.vue?vue&type=template&id=29ab93a0"
import script from "./TransportadoraTpCalcImportarForm.vue?vue&type=script&lang=js"
export * from "./TransportadoraTpCalcImportarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports